import { render, staticRenderFns } from "./Pool.vue?vue&type=template&id=518e587d&scoped=true&"
import script from "./Pool.vue?vue&type=script&lang=js&"
export * from "./Pool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518e587d",
  null
  
)

export default component.exports